export default {
  common_button_back: 'Tagasi',
  common_button_cancel: 'Tühista',
  common_button_next: 'Järgmise',
  common_button_no: 'Ei',
  common_button_ok: 'Korras',
  common_button_reset: 'Lähtestamine',
  common_button_skip: 'Jäta vahele',
  common_button_yes: 'Jah',
  common_deactivated_message: 'Seda kioski kasutatakse praegu teises seadmes. Palun logige uuesti sisse. Tänan!',
  common_deactivated_title: 'Kiosk on deaktiveeritud',
  common_enterEmail_email: 'Palun sisesta oma töökoha meiliaadress',
  common_enterEmail_title: 'Sinu meiliaadress',
  common_error_message_cameraNotAllowed: 'Kaamerale ligipääsuks peab antud funktsioon olema lubatud.',
  common_error_message_ForbiddenException: 'Ebapiisavad õigused',
  common_error_message_incorrectEmail: 'Palun sisesta korrektne meiliaadress',
  common_error_message_invalidCredentials: 'Kasutajanimi ja/või parool on valesti. Palun proovi uuesti',
  common_error_message_invalidMobile: 'Palun sisesta toimiv mobiiltelefoni number',
  common_error_message_missingField: 'Kohustuslik väli',
  common_error_message_noInternetConnection: 'Internetiühendus katkes. Palun proovi uuesti.',
  common_error_message_unauthorizedAccess: 'Volitamata juurdepääs',
  common_error_message_webServiceWrongConnection: 'Andmeedastusel tekkis viga. Palun proovi uuesti',
  common_error_title: 'Tõrge',
  common_expired_message:
    'Prooviversioon on aegunud või krediitkaart ei toimi enam. Palun tehke uuendus konto reaktiveerimiseks. Küsimuste korral kontakteeruge sales@proxyclick.com. Tänan!',
  common_expired_title: 'Konto on aegunud',
  common_onboarding_login_button: 'Logi sisse',
  common_onboarding_message1: 'Proxyclick aitab tervitada külalisi teile sobival viisil.',
  common_onboarding_message2:
    'Kohandage sobivalt registreerimisprotsess ja nimesildid ning küsige külalistelt ainult vajalikke küsimusi.',
  common_onboarding_message3:
    'Võõrustajaid informeeritakse külalise saabumisest ja võimaldatakse koheselt ka vastus saata.',
  common_onboarding_message4:
    'Kaitske oma rajatisi ja tagage turvalisus kasutades hädaolukorra nimekirju, külastusreegeleid, kokkuleppeid...',
  common_onboarding_message5: 'Proxyclick teeb tublit tööd ja te saate tervitada oma külalisi naeratusega.',
  common_placeholder_optional: 'Valikuline',
  common_setup_activationCode_activate_button: 'Aktiveeri',
  common_setup_activationCode_code: 'Enter your activation code',
  common_setup_activationCode_code_placeholder: 'Nt. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_error_invalidCode: 'Vigane aktiveerimiskood',
  common_setup_activationCode_footer: 'Activation code is handy for SSO admins or for local guards. Learn More.',
  common_setup_activationCode_title: 'Aktiveeri kiosk unikaalse koodiga',
  common_setup_device_footer: 'Uue kioski loomiseks sisene Proxyclick veebirakendusse',
  common_setup_device_locked_content:
    'Seda kioskit kasutab juba teine iPad. Sellele seadmele seadistamine deaktiveerib kioski teise seadme peal. Oled sa kindel, et soovid seadistada kioski selle seadme peal?',
  common_setup_device_locked_continue_button: 'Seadista kiosk',
  common_setup_device_locked_title: 'Kiosk on juba kasutuses',
  common_setup_device_multiTenants: 'Ettevõtete grupp',
  common_setup_device_title: 'Vali oma kiosk',
  common_setup_loading_footer: 'Uue kioski loomiseks sisene Proxyclick veebirakendusse',
  common_setup_loading_message: 'Konfigureerimine...',
  common_setup_loading_title: 'Kiosk on loomisel...',
  common_setup_location_footer: 'Uue kioski loomiseks sisene Proxyclick veebirakendusse',
  common_setup_location_kiosk: 'kiosk',
  common_setup_location_kiosks: 'kioskid',
  common_setup_location_title: 'Vali oma ettevõtte asupaik',
  common_setup_login_activationCode_button: 'Aktiveerida kiosk unikaalse koodiga?',
  common_setup_login_email: 'Meiliaadress',
  common_setup_login_forgotPassword_button: 'Kas unustasid parooli?',
  common_setup_login_password: 'Parool',
  common_setup_login_title: 'Logi sisse oma Proxyclick kontoga',
  common_setup_ready_header: 'Oled valmis, et seadistada see iPad kui {0} kiosk?',
  common_setup_ready_message: 'Kioski konfigureerimine võtab vaid mõne hetke ja kiosk on tööks valmis',
  common_setup_ready_setup_button: 'Seadista',
  common_setup_ready_title: 'Tere {0}',
  common_signup_company: 'Ettevõte',
  common_signup_email: 'Meiliaadress',
  common_signup_error_name: 'Palun sisesta ees- ja perenimi',
  common_signup_loading_message1:
    "Kioski seadeid saab kohandada Proxyclick'i veebirakenduses. Just saatsime sulle meili vastavate andmetega.",
  common_signup_loading_message2: 'Veebilehel saab seadistada printerit siltide sissekirjutuse käigus trükkimiseks.',
  common_signup_loading_message3:
    'Samuti saab võimaldada külalise vastuvõtjale teatise saatmise külalise saabumise kohta.',
  common_signup_loading_message4: 'Kohanda kioski värve ning lisa oma tervituspilt.',
  common_signup_loading_title: 'Konto loomine …',
  common_signup_name: 'Nimi',
  common_signup_name_placeholder: 'Eesnimi perekonnanimi',
  common_signup_password: 'Parool',
  common_signup_title: 'Proxyclick tervitab',
  common_signup_tryFree_button: 'Esita',
  common_timeout_content: 'Puuduta katkestamiseks',
  common_timeout_title: 'Avakuva avamine',
  common_tooltip_disable_button: 'Keela kõik juhendamised',
  common_tooltip_gotIt_button: 'Sain aru',
  dm_delivery_confirmation_knownRecipient: '{{Host_Name}} on saanud teavituse, et talle on saabunud pakk',
  dm_delivery_confirmation_title: 'Tänan!',
  dm_delivery_confirmation_unknownRecipient:
    'Firmale {{Company_Name}} on saadetud teavitus, et sa oled saatnud neile saadetise',
  dm_delivery_recipient_name: 'Kellele see saadetis on?',
  dm_delivery_recipient_unknown_button: 'Ma ei tea',
  em_multiTenant_alreadyRegistered_button: 'Tap here if you are an employee or have received a QR code to check in',
  em_multiTenant_notRegistered_button: 'Tap here to check in manually',
  vm_checkin_approval_confirmation_unregistered_message:
    'We are unable to check you in at this time. Please contact your host or reach out the reception for assistance.',
  vm_checkin_approval_confirmation_unregistered_title: 'Welcome {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'We are unable to finalize your check-in at this time. Please contact your host or reach out to reception for assistance.',
  vm_checkin_approval_notapproved_title: 'Dear {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_confirmation_header_withoutPrint: 'Oled registreeritud!',
  vm_checkin_confirmation_header_withPrint: 'Silti trükitakse',
  vm_checkin_confirmation_message: 'Palun võta istet, {{Host_FirstName}} tuleb varsti',
  vm_checkin_confirmation_takeBackID: "Please don't forget your ID",
  vm_checkin_confirmation_title: 'Tänan!',
  vm_checkin_details_companyName: 'Ettevõte',
  vm_checkin_details_email: 'Meiliaadress',
  vm_checkin_details_firstname: 'Eesnimi',
  vm_checkin_details_lastname: 'Perekonnanimi',
  vm_checkin_details_title: 'Please enter your details',
  vm_checkin_error_message_unableToCheckIn:
    'Sisse registreerimise lõpuleviimisel tekkis viga. Palun võta ühendus vastuvõtu töötajaga',
  vm_checkin_flow_company: 'Ettevõte',
  vm_checkin_flow_duration: 'Kestus',
  vm_checkin_flow_email: 'Meiliaadress',
  vm_checkin_flow_error_message_imageNotAvailable: 'Vabandust, pilt pole praegu saadaval (Interneti-ühenduse probleem)',
  vm_checkin_flow_licensePlate: 'Numbrimärk',
  vm_checkin_flow_mobile: 'Palun sisesta oma mobiiltelefoni number',
  vm_checkin_flow_mobile_info:
    'Seda kasutatakse hädaolukorra puhul sinuga ühenduse võtmiseks sinu territooriumil viibimise ajal',
  vm_checkin_flow_tooltip_content:
    'Külaliste vastuvõtu parendamiseks või sissekirjutuse turvalisuse tõstmiseks saad esitada külalistele lisaküsimusi. Saad muuta küsimuste kulgu olenevalt vastustest. Küsimused, mida sa näed on vaid näidised.',
  vm_checkin_flow_tooltip_title: 'Nutikad küsimused',
  vm_checkin_host_enterFullName: 'Palun sisesta külastatava täielik nimi',
  vm_checkin_host_name: 'Keda sa külastad?',
  vm_checkin_host_notListed_block:
    'Kui sa ei tea oma võõrustajat või ei leia teda nimekirjast, siis suhtle vastuvõtu töötajaga',
  vm_checkin_host_notListed_continue: 'Pole nimekirjas',
  vm_checkin_host_tooltip_content:
    'Sisesta siia oma nimi ja me saadame sulle meiliteatise, millise saavad töötajad kui nende külalised saabuvad.',
  vm_checkin_host_tooltip_title: 'Külalise saabumise teatis',
  vm_checkin_host_unknown_button: 'Ma ei tea',
  vm_checkin_idScan_aila_footer: 'This screen is skipped when you use the recommended hardware ({0})',
  vm_checkin_idScan_aila_header: 'Please scan your ID',
  vm_checkin_idScan_aila_learnMore: 'Lisateave',
  vm_checkin_idScan_aila_scan_button: 'Scan ID',
  vm_checkin_idScan_back_picture_header_aila: 'Place your ID in the holder so the back faces the camera.',
  vm_checkin_idScan_back_picture_header_noAila: 'Position the back of your ID entirely inside the frame.',
  vm_checkin_idScan_back_picture_take_button: 'Scan back',
  vm_checkin_idScan_cancel_message: 'Check-in will be cancelled and you will return to home screen',
  vm_checkin_idScan_cancel_title: 'Warning',
  vm_checkin_idScan_disclaimer_start_button: "Let's get started",
  vm_checkin_idScan_disclaimer_text:
    'As part of our security policy, we need to verify your identity using your ID. \n\nWe value your privacy, so we will not store the picture of your ID. Reception officers are available to help if you have any questions.',
  vm_checkin_idScan_editName_title: 'Please fill in your first and last name',
  vm_checkin_idScan_front_picture_header_aila: 'Place your ID in the holder so the front faces the camera.',
  vm_checkin_idScan_front_picture_header_noAila: 'Position your ID entirely inside the frame.',
  vm_checkin_idScan_front_picture_take_button: 'Scan front',
  vm_checkin_idScan_match_check: 'Comparing the two pictures',
  vm_checkin_idScan_match_confirm_button: 'Confirm',
  vm_checkin_idScan_match_error_default_header: 'Sorry, something went wrong.',
  vm_checkin_idScan_match_error_default_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idExpired_header: 'Sorry, your ID seems to have expired.',
  vm_checkin_idScan_match_error_idExpired_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Sorry, we could not identify a face on your ID.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_pictureNoFace_header: 'Sorry, we could not identify a face on the picture you took.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_region_0: ' United States',
  vm_checkin_idScan_region_1: ' Canada',
  vm_checkin_idScan_region_2: 'South America',
  vm_checkin_idScan_region_3: ' Europe',
  vm_checkin_idScan_region_4: ' Australia',
  vm_checkin_idScan_region_5: ' Asia',
  vm_checkin_idScan_region_6: ' General Documents',
  vm_checkin_idScan_region_7: ' Africa',
  vm_checkin_idScan_region_header: 'What region does your ID come from?',
  vm_checkin_instructions_agreeTerms_button: 'Nõus',
  vm_checkin_instructions_clearSignature_button: 'Puhasta',
  vm_checkin_instructions_sendCopy_button: 'Saada mu meilile koopia',
  vm_checkin_instructions_sendCopyTo_button: 'Koopia saadetakse {0}',
  vm_checkin_instructions_sign: 'Kirjuta alla kasutades oma sõrme',
  vm_checkin_instructions_tooltip_content:
    'Võimalda oma külalistel aktsepteerida külastusreegleid lihtsa puudutuse või allkirjaga ekraanil. Võimalik on kohandada külastustingimusi vastavalt külaliste tüüpidele. Kohanda seda ja mitmeid teisi funktsioone Proxyclick rakenduse töölaual.',
  vm_checkin_instructions_tooltip_title: 'Allkirjastatud ja jõustunud',
  vm_checkin_method_name: 'Tere, mis su nimi on?',
  vm_checkin_method_name_enterFullName: 'Palun sisestage oma täielik nimi',
  vm_checkin_method_name_invitationQuestion: 'Did you receive an invitation with a QR-code?',
  vm_checkin_method_name_notRegistered_block: 'Kas pole nimekirjas? Palun suhtele vastuvõtu töötajaga',
  vm_checkin_method_name_notRegistered_continue: 'Kas pole nimekirjas?',
  vm_checkin_method_tooltip_content:
    'Registreeru sisse kui "Justin Diaz", et näha kuidas korduv- või eelregistreeritud külalised tuvastatakse või trüki suvaline nimi, et näha kuidas mitteoodatud külalisi suunatakse.',
  vm_checkin_method_tooltip_title: 'Külalise tuvastamine',
  vm_checkin_picture_auto_countDown: ' ',
  vm_checkin_picture_auto_lookCamera: 'Please look at the camera, we will take your visitor picture',
  vm_checkin_picture_auto_pictureTaken: 'Picture taken',
  vm_checkin_picture_auto_stayStill: 'Remain still',
  vm_checkin_picture_take_button: 'Pildista',
  vm_checkin_picture_title: 'Soovime sind pildistada!',
  vm_checkin_picture_tooltip_content:
    'Sa saad kohandada kioski oma vajaduste järgi lihtsalt lisades või eemaldades funktsioone nagu näiteks külalise pildi tegemine või sildi trükkimine.',
  vm_checkin_picture_tooltip_title: 'Valikulised funktsioonid',
  vm_checkin_qrcode_no_checkin_allowed: 'Checkin not allowed. Please contact the reception for assistance.',
  vm_checkin_returning_email: 'Mis on su meiliaadress?',
  vm_checkin_returning_email_notRegistered:
    'We could not find a scheduled visit linked to your email address. Please check with reception or try again with a different email address.',
  vm_checkin_saveInfo_email: 'Salvesta minu andmed, et kiirendada minu järgmise külastuse sisse registreerumist',
  vm_checkin_saveInfo_email_placeholder: 'Sisesta oma meiliaadress',
  vm_checkin_saveInfo_title: 'Sisesta oma e-post',
  vm_checkin_summary_agreementAlreadySigned: 'Agreement already signed',
  vm_checkin_summary_checkin_button: 'Registreeri sisse',
  vm_checkin_summary_countDown: 'You will be checked in after',
  vm_checkin_summary_editDetails_button: 'Redigeeri üksikasju',
  vm_checkin_summary_groupStats: '{0} kokku {1} inimest juba kohal',
  vm_checkin_summary_meetingTime: 'Kohtumised {0}',
  vm_checkin_summary_reviewDetails_button: 'Vaata külastuse üksikasju',
  vm_checkin_summary_sendPass_button: 'Saada mu nutitelefonile pass tuleviku külastuste jaoks',
  vm_checkin_summary_sendPassTo_button: 'Alaline pass saadetakse {0} (Muuda)',
  vm_checkin_summary_takeNewPicture_button: 'Tee uus pilt',
  vm_checkin_summary_title: 'Külastad ettevõtet {{Company_Name}}',
  vm_checkin_summary_visiting: 'Külalisi {0}',
  vm_checkin_video_duration: 'Duration',
  vm_checkin_video_subtitle: 'Watch the full video to continue your check-in.',
  vm_checkin_welcome_firstTime: 'Tere {{Visitor_FirstName}}!',
  vm_checkin_welcome_lastVisit_date: 'Su viimane külastus oli {0}',
  vm_checkin_welcome_lastVisit_today: 'Su viimane külastus oli eelnevalt täna',
  vm_checkin_welcome_lastVisit_yesterday: 'Su viimane külastus oli eile',
  vm_checkin_welcome_returning: 'Tere tulemast tagasi {{Visitor_FirstName}}!',
  vm_checkout_confirmation_header: 'Nägemiseni {{Visitor_FirstName}}!',
  vm_checkout_confirmation_message: 'Oled välja registreerunud. Loodetavasti oli külastus meeldiv.',
  vm_checkout_confirmation_title: 'Täname külastuse eest!',
  vm_checkout_method_name: 'Välja registreerimiseks palun sisesta oma nimi',
  vm_checkout_method_name_notFound: 'Ei leitud',
  vm_checkout_method_title: 'Registreeri välja',
  vm_identification_id_button: 'Skanneeri oma ID',
  vm_identification_qrCode_button: 'Skanneeri oma kutse/pass',
  vm_infopack_confirmation: 'Aitäh! Saatsime informatsiooni aadressile {0}.',
  vm_infopack_email: 'Palun sisesta oma meiliaadress, et saaksime saata teavet Proxyclick kohta',
  vm_infopack_likeCheckIn: 'Sissekirjutus meeldis? Vajuta siia, et rohkem teada saada',
  vm_infopack_likeProcess: 'Protsess meeldis? Vajuta siia, et rohkem teada saada',
  vm_infopack_send_button: 'Saatke mulle infot',
  vm_multiTenant_title: 'Tere, mis ettevõtet sa külastad?',
  vm_product_footer_learnMore: 'Lisateave',
  vm_product_footer_noPartner: 'Kasutusel on Proxyclick Welcome',
  vm_product_footer_partner: 'Kasutusel on Proxyclick Welcome, mille tõi teieni {0}',
  vm_qrCode_help: 'Hoia koodi kaamerast 10-15 cm kaugusel',
  vm_qrCode_not_recognized: 'Tundmatu kood',
  vm_qrCode_title: 'Skanneeri oma sildi või Passbooki kood',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>KÜLASTUSE JUHEND JA KONFIDENTSIAALSUSE KOKKULEPE</h1><p>Tere tulemast! Meil on hea meel, et külastate meie ettevõtet {{Company_Name}}.</p><h2>Tervise ja ohutuse juhend</h2><p>Sinu ohutus on meie mure kogu sinu külastuse ajal. Seetõttu palume, et järgiksid juhiseid:</p><ul><li><b>Ligipääs territooriumile</b> on lubatud ainult ettevõtte {{Company_Name}} töötaja seltsis.</li><li><b>Külalise silti</b> peab kandma kogu visiidi kestel.</li><li><b>Hädaolukorras</b> peavad kõik külalised viivitamatult lahkuma lähima ohutu väljapääsu kaudu ja raporteerima selleks ettenähtud kogunemiskohas.</li><li>Ilma ettevõtte loata on külalistel ettevõtte territooriumil <b>keelatud pildistada ja filmida</b>.</li><li><b>Suitsetamine on rangelt keelatud nii välisterritooriumil kui ruumides</b>, välja arvatud spetsiaalselt kohandatud ja märgistatud suitsetamiskohtades.</li></ul><h2>Avalikustamise keelu kokkulepe</h2><p>Ettevõtte {{Company_Name}} valdustes viibimise ajal võid sa teada saada konfidentsiaalset informatsiooni. Konfidentsiaalseks loetakse informatsiooni (sealhulgas tehnoloogiad, protsessid, seadmed, joonised ja spetsifikatsioonid), mis ei ole avalikkusele üldteada.</p><p>Vastavalt ettevõtte {{Company_Name}} külastusvisiidi tingimustele ei tohi sa:</p><p>(a) avalikustada ega teha teistele kättesaadavaks mingit konfidentsiaalset informatsiooni, mille sa oled teada saanud või muud moodi omandanud selle või järgnevate külastuste käigus</p><p>(b) kasutada või aidata teistel mistahes viisil rakendada konfidentsiaalset informatsiooni</p><p>(c) kasutada infotehnoloogiat ja foto- või videotehnoloogiat viisil, mis võib põhjustada konfidentsiaalse informatsiooni lekke avalikkusele või teistele isikutele</p><p>Alla kirjutades sa kinnitad, et aktsepteerid ja saad aru "Tervise ja ohutuse juhendist" ning "Avalikustamise keelu kokkuleppest".</p>',
  vm_signup_defaultInstruction_name: 'Juhendid külastajatele allkirjastamiseks',
  vm_signup_defaultInstruction_title: 'Palun loe läbi ja allkirjasta',
  vm_vaccine_certification_accessDenied_button: 'Okay',
  vm_vaccine_certification_accessDenied_message:
    "Sorry you don't meet the vaccination requirements to enter the premisses",
  vm_vaccine_certification_accessDenied_title: 'Access has been denied',
  vm_vaccine_certification_declare_question_title:
    'Dear visitor, please declare whether you have a valid COVID vaccine certificate or a COVID test with a negative result',
  vm_vaccine_certification_intro_question_title: 'Dear visitor, do you have an EU COVID Vaccine Certificate?',
  vm_vaccine_certification_scanner_donthaveaqrcode: "I don't have a QR code",
  vm_vaccine_certification_scanner_subtitle:
    'Make sure that your QR code is enlarged and the brightness of your mobile phone is on maximum.',
  vm_vaccine_certification_scanner_title: 'Please present the QR code of your EU COVID certificate to the camera',
  vm_welcome_changeLanguage_button: 'Change Language',
  vm_welcome_checkin_button: 'Registreeri sisse',
  vm_welcome_checkout_button: 'Registreeri välja',
  vm_welcome_delivery_button: 'Saadetis',
  vm_welcome_hello_line1: 'Tere,',
  vm_welcome_hello_line2: 'ettevõttesse {{Company_Name}}',
  vm_welcome_qrCode_checkedIn: "Welcome {0}, don't forget to check out before leaving",
  vm_welcome_qrCode_checkedOut: 'Thank you for visiting, {0}!',
  vm_welcome_qrCode_notRecognized: 'This QR code is not recognized. Please try again.',
  vm_welcome_qrCode_scan: 'Pre-registered Visitors: hold your QR code up to the camera for check-in or out',
  vm_welcome_qrCode_show: 'Employees: scan this QR code with Proovr to check in or check out',
  vm_welcome_qrCode_wrongCompany: 'Your QR code is invalid for this location.',
  vm_welcome_returning_button: 'Olen siin varem olnud',
  vm_welcome_title: 'Tere tulemast ettevõttesse {{Company_Name}}',
  vm_welcome_tooltip_content:
    'Kioski isikupärastamiseks logi Proxyclik veebirakendusse. Me just saatsime sulle meili koos juhendusega. Veebirakenduses saad üles laadida oma logo, taustapildi ja muuta värve nii, et kiosk kajastaks sinu kaubamärgi identiteeti.',
  vm_welcome_tooltip_title: 'Muutke see omaseks',
  vm_welcome_touchless_employee_qrCode_show: 'Scan this QR code with Proovr to check in as an employee',
  vm_welcome_touchless_qrCode_show: 'Unregistered Visitors: Scan this QR code for touchless check-in',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Scan this QR code with Proovr (employees) or your phone (visitors) to check in',
  vm_welcome_touchless_unexpected_qrCode_show: 'Scan this QR code with your phone to check in as a visitor',
  common_or: 'või',
};
